<template>
    <div class="dress-page" :class="className">
        <section v-if="needLogin" class="no-data">
            <div class="login-text">
                <p class="login-p">请先授权登录，再查看数据</p>
            </div>
            <div class="orange-btn-box">
                <button class="orange-btn" @click="clickLogin">授权登录</button>
            </div>
        </section>

        <section v-else class="main-content">
            <section class="section-top-one shadow-no-bottom">
                <div v-if="!isToday" class="btn-now" @click="clickNow">今</div>
                <TitleInfo :className="className" :title-text="titleText"></TitleInfo>
                <TopInfo :date-info="dateInfo" :is-min="isMinDate" :is-max="isMaxDate" :preFunc="clickPreDate"
                    :nextFunc="clickNextDate" :dayFunc="clickDate"></TopInfo>
            </section>
            <div class="inner-box-border">
                <div class="inner-box-left"> </div>
                <div class="inner-box-line"><span class="line"></span></div>
                <div class="inner-box-right"></div>
            </div>
            <section class="section-top-two shadow-no-top">
                <TotalInfo :className="className" :total-info="totalInfo"></TotalInfo>
                <div class="outer-box">
                    <div class="outer-line outer-line-l"></div>
                    <div class="outer-line outer-line-r"></div>
                </div>
            </section>

            <section class="section-mid m-t-1">
                <div class="color-info" v-for="colorItem in colorArr" :key="colorItem.colorClass"
                    :class="colorItem.colorClass">
                    <div class="color-top">
                        <div class="color-title"><span class="title-text" :class="colorItem.colorClass">{{ colorItem.rank
                            <= 2 ? colorItem.rankText+'色' : colorItem.rankText}}</span>
                        </div>
                        <div class="color-img-box">
                            <div class="color-img" :class="colorItem.colorClass"></div>
                            <p class="color-img-text" :class="colorItem.colorClass">{{ colorItem.colorText }}等</p>
                        </div>
                    </div>
                    <div class="color-content">
                        <p>{{ colorItem.msg }}</p>
                    </div>
                </div>
            </section>

            <TipsInfo></TipsInfo>
            <div class="tips-popup" v-if="showPopup" @click="clickPopup">
                <div class="tips-popup-top">
                    <div class="tips-popup-arrow"></div>
                </div>
                <div class="tips-popup-content">
                    <div class="tips-popup-text">建议点击『浮窗』开启浮窗，以后只需要每天在微信首页点击左上角『..』即可进入五行穿衣页面。</div>
                </div>
            </div>
            <div class="bottom-box">
                <button class="orange-btn-two" @click="clickCheck">查看您的个人运势</button>
                <div class="qr-box"><img class="qr-code" src="../../assets/images/dress/code.png" /></div>
            </div>
        </section>

        <van-popup v-model:show="showDatePicker" position="bottom" @click-overlay="onClickOverlay">
            <van-datetime-picker 
                type="date"
                v-model="curDate" 
                :formatter="formatter" 
                :min-date="minDate" 
                :max-date="maxDate"
                @cancel="cancelDatePicker" 
                @confirm="confirmDatePicker">
            </van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import * as doctitle from '../../modules/data/base/doctitle'
import login from '../../modules/login';
import TitleInfo from '../../components/dress/TitleInfo.vue';
import TopInfo from '../../components/dress/TopInfo.vue';
import TipsInfo from '../../components/dress/TipsInfo.vue';
import TipsPopup from '../../components/dress/TipsPopup.vue';
import TotalInfo from '../../components/dress/TotalInfo.vue'
import { DOM } from '../../modules/dom';
import { UTILS } from '../../modules/utils';
import { CONFIG } from '../../modules/config';
export default {
    name: 'Dress',
    components: { TitleInfo, TopInfo, TipsInfo, TipsPopup, TotalInfo },
    computed: {
        needLogin() {
            return this.$store.state.userData && this.$store.state.userData.info ? false : true;
        },
        className() {
            return this.$store.state.dress.className;
        },
        titleText() {
            return this.$store.state.dress.titleText;
        },
        dateInfo() {
            return this.$store.state.dress.dateInfo;
        },
        totalInfo() {
            return this.$store.state.dress.totalInfo;
        },
        colorArr() {
            return this.$store.state.dress.colorArr;
        },
        allExtListData() {
            return this.$store.state.reminder.allExtListData;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            showPopup: false,
            showDatePicker: false,
            isToday: true,
            curDate: ['2024', '6', '19'],
            minDate: new Date(2024, 5, 18),
            maxDate: new Date(2024, 5, 26),
            currentDate: new Date(),
            isMinDate: false,
            isMaxDate: false,
        }
    },
    mounted() {
        setTimeout(() => {
            this.initDate();
            this.getData();
            DOM.setDocumentTitle(doctitle.TITLE_DRESS);
        }, 100);
    },
    methods: {
        initDate() {
            let year = this.currentDate.getFullYear(), month = this.currentDate.getMonth(), day = this.currentDate.getDate();
            this.curDate = [year.toString(), (month + 1).toString(), day.toString()];
            console.log('initDate------', year, month, day)
            this.minDate = UTILS.getNextDate(this.currentDate, -1);
            this.maxDate = UTILS.getNextDate(this.currentDate, 7);
            setTimeout(() => {
                this.showPopup = this.allExtListData && this.allExtListData['wxcy_popup_status'] && parseInt(this.allExtListData['wxcy_popup_status']) == 1 ? false : true;
            }, 3000); 
        },
        getData() {
            this.$store.dispatch('dress/initDressData', {time: parseInt((this.currentDate.getTime()/1000).toString(), 10)});
        },
        clickLogin() {
            // 授权登录
            login.checkLogin();
        },
        clickPopup() {
            this.showPopup = false;
            this.$store.dispatch('reminder/udpateExtList', {
                params: {
                    wxcy_popup_status: 1
                }
            });
        },
        clickPreDate() {
            if (this.currentDate.getTime() <= this.minDate.getTime()) {
                return;
            }
            let newDate = UTILS.getNextDate(this.currentDate, -1);
            this.currentDate = newDate;
            this.updateCurDate();
            this.getData();
            this.isToday = false;
        },
        clickDate() {
            this.showDatePicker = true;
        },
        formatter(type, val) {
            if (type === 'month') {
                return `${val}月`;
            } else if (type === 'day') {
                return `${val}日`;
            }
            return val;
        },
        clickNextDate() {
            if (this.currentDate.getTime() >= this.maxDate.getTime()) {
                return;
            }
            let newDate = UTILS.getNextDate(this.currentDate, 1);
            this.currentDate = newDate;
            this.updateCurDate();
            this.getData();
            this.isToday = false;
        },
        onClickOverlay() {
            this.showDatePicker = false;
        },
        cancelDatePicker() {
            this.showDatePicker = false;
        },
        confirmDatePicker(value) {
            this.showDatePicker = false;
            this.currentDate = value;
            this.updateCurDate();
            this.getData();
            this.isToday = false;
        },
        clickNow() {
            if (this.isToday) { return; }
            console.log('clickNow')
            this.currentDate = new Date();
            this.updateCurDate();
            this.getData();
            this.isToday = true;
        },
        updateCurDate() {
            let year = this.currentDate.getFullYear(), month = this.currentDate.getMonth(), day = this.currentDate.getDate();
            this.curDate = [year.toString(), (month + 1).toString(), day.toString()];
            this.isMinDate = this.currentDate.getTime() <= this.minDate.getTime();
            this.isMaxDate = this.currentDate.getTime() >= this.maxDate.getTime();
            console.log('updateCurDate------', year, month, day)
        },
        clickCheck() {
            setTimeout(() => {
                CONFIG.platform_params.platform = 55; //以五行穿衣平台的方式进入
                this.$router.replace('/collate');
            }, 20);
        }

    }
}
</script>

<style scoped>
.dress-page {
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
    padding: 1rem;
    font-weight: normal;
    min-height: 100vh;
    background: #FBF5EF;
    position: relative;
}
.dress-page.solid { background: #FBF5EF; } /*土*/
.dress-page.wood { background: #F8FFF5; } /*木*/
.dress-page.fire { background: #FFDCDC; } /*火*/
.dress-page.gold { background: #FBFBFB; } /*金*/
.dress-page.water { background: #E8EEFC; } /*水*/

section {
    border-radius: 0.5rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.06);
}

.no-data {
    height: 90vh;
}

.main-content {
    background: transparent;
    box-shadow: none;
}

.login-text {
    color: #666;
    text-align: center;
    padding: 30vh 0 2rem 0;
}

.section-top-one {
    padding: 0 1.5rem 1rem;
    border-radius: 0.5rem 0.5rem 0 0;
    position: relative;
}

.btn-now {
    position: absolute;
    top: 0.5rem;
    right: 2.5rem;
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: 50%;
    text-align: center;
    font-size: 0.9rem;
    font-weight: 500;
    color: #FFF;
    background: linear-gradient(315deg, #FC443B 0%, #FD6D27 100%);
}

.section-top-two {
    padding: 1rem 1.5rem;
    border-radius: 0 0 0.5rem 0.5rem;
}

.section-mid {
    padding: 3rem 1.5rem;
    border-radius: 0.5rem;
}

.shadow-no-top {
    box-shadow: -4px 4px 8px -4px rgba(0, 0, 0, 0.06), 4px 4px 8px -4px rgba(0, 0, 0, 0.06);
}

.shadow-no-bottom {
    box-shadow: -4px -4px 8px -4px rgba(0, 0, 0, 0.06), 4px -4px 8px -4px rgba(0, 0, 0, 0.06);
}

.inner-box-border {
    width: 100%;
    height: 1.5rem;
    display: flex;
    box-shadow: none;
}

.inner-box-left,
.inner-box-right {
    width: 0.75rem;
    height: 1.5rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.inner-box-left {
    background-image: url('../../assets/images/dress/bg-radius-l.png');
}

.inner-box-right {
    background-image: url('../../assets/images/dress/bg-radius-r.png');
}

.inner-box-line {
    width: 100%;
    background: #FFFFFF;
    text-align: center;
    line-height: 1rem;
    padding: 0 0.75rem;
}

.inner-box-line .line {
    display: inline-block;
    width: 100%;
    border-bottom: dashed 1px #979797;
}

.orange-btn-box {
    width: 100%;
    height: 2.5rem;
    text-align: center;
    padding: 1rem 0 2rem 0;
}

.orange-btn {
    width: 9.5rem;
    height: 2.5rem;
    font-size: 0.85rem;
    font-weight: 600;
    color: #FFF;
    text-shadow: 0px 1px 1px #D66900;
    border: none;
    outline: none;
    background: url('../../assets/images/dress/bg-button.png');
    background-size: 100% 100%;
}

.bottom-box {
    position: fixed;
    bottom: 1rem;
    left: 0;
    width: 100%;
    height: 4.2rem;
    display: flex;
    background: transparent;
    padding: 0 1rem;
}

.orange-btn-two {
    width: 75%;
    height: 4.2rem;
    font-size: 1rem;
    font-weight: 600;
    color: #FFF;
    border: none;
    outline: none;
    background: #02C160;
    border-radius: 10px 0 0 10px;
}

.qr-box {
    width: 25%;
    height: 4.2rem;
    padding: 0.1rem 0;
    text-align: center;
    background: #FFE9C6;
    border-radius: 0 10px 10px 0;
}

.qr-code {
    display: inline-block;
    width: 4rem;
    height: 4rem;
}

.outer-box {
    width: 100%;
    height: 4rem;
    position: relative;
    margin-top: 1rem;
    margin-bottom: -3.75rem;
}

.outer-line {
    position: absolute;

    width: 1rem;
    height: 4rem;
    background: url('../../assets/images/dress/bg-link.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.outer-line-l {
    left: 2rem;
}

.outer-line-r {
    right: 2rem;
}

.color-info {
    border-width: 2px;
    border-style: solid;
    border-radius: 0.5rem;
    margin-top: 2rem;
}

.color-info:first-child {
    margin-top: 0;
}

.color-top {
    padding: 1rem;
}

.color-info.white {
    background: #FBFBFB;
    border-color: #D8D8D8;
}

.color-info.yellow {
    background: #FFFAF4;
    border-color: #FFE8B7;
}

.color-info.green {
    background: #F8FFF5;
    border-color: #C6F1DE;
}

.color-info.red {
    background: #FFEFEF;
    border-color: #FFCECE;
}

.color-info.blue {
    background: #EEF3FF;
    border-color: #D0DEFA;
}

.color-title {
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
}

.title-text {
    display: inline-block;
    line-height: 0.85rem;
    font-weight: 600;
    border-bottom-width: 5px;
    border-bottom-style: solid;
}

.title-text.white {
    color: #999;
    border-bottom-color: rgba(168, 168, 168, 0.40)
}

.title-text.yellow {
    color: #D99300;
    border-bottom-color: #FFE8B7;
}

.title-text.green {
    color: #00B880;
    border-bottom-color: #C6F1DE;
}

.title-text.red {
    color: #FA5959;
    border-bottom-color: #FFCECE;
}

.title-text.blue {
    color: #175CE5;
    border-bottom-color: #D2E0FF;
}

.color-img-box {
    text-align: center;
    padding: 0.5rem 0;
}

.color-img {
    width: 60%;
    margin: 0 auto;
    min-height: 3.2rem;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center top;
}

.color-img.white {
    background-image: url('../../assets/images/dress/color/white.png');
}

.color-img.yellow {
    background-image: url('../../assets/images/dress/color/yellow.png');
}

.color-img.green {
    background-image: url('../../assets/images/dress/color/green.png');
}

.color-img.red {
    background-image: url('../../assets/images/dress/color/red.png');
}

.color-img.blue {
    background-image: url('../../assets/images/dress/color/blue.png');
}

.color-img-text {
    line-height: 1rem;
    font-size: 0.9rem;
}

.color-img-text.white {
    color: #999;
}

.color-img-text.yellow {
    color: #D99300;
}

.color-img-text.green {
    color: #00B880;
}

.color-img-text.red {
    color: #FA5959;
}

.color-img-text.blue {
    color: #175CE5;
}

.color-content {
    padding: 1rem;
    background: #fff;
    border-radius: 0.5rem;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #191919;
}

.white { color: #999999; }
.yellow { color: #D99300; }
.green { color: #00B880; }
.red { color: #FA5959; }
.blue { color: #175CE5; }
.m-t-1 { margin-top: 1.5rem; }
.m-b-2 { margin-bottom: 2rem; }

.tips-popup {
    position: fixed;
    top: 0;
    right: 1rem;
    width: 16rem;
}
.tips-popup-top {
    text-align: right;
}
.tips-popup-arrow {
    display: inline-block;
    width: 3rem;
    height: 2.5rem;
    background-image: url('../../assets/images/dress/tips-arrow2.png');
    background-repeat: no-repeat;
    background-position: right top;
    background-size: 100% auto;
}
.tips-popup-content {
    padding: 1rem;
    border-radius: 0.5rem;
    background: rgba(0,0,0,0.86);
}
.tips-popup-text {
    color: #FFFFFF;
    font-size: 0.9rem;
}

</style>
